"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzContainer = _interopRequireDefault(require("./../OzContainer/OzContainer.js"));

var _OzRow = _interopRequireDefault(require("./../OzRow/OzRow.js"));

var _OzCol = _interopRequireDefault(require("./../OzCol/OzCol.js"));

var _OzLogo = _interopRequireDefault(require("./../OzLogo/OzLogo.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Container",
  componentId: "sc-1hhb1mv-0"
})(["\n  padding: 35px 0px;\n  width: 100%;\n  background-color: ", ";\n  color: ", ";\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], _consts.CHARCOAL, _consts.WHITESMOKE);

var Menu = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Menu",
  componentId: "sc-1hhb1mv-1"
})(["\n\n\n\n\n"]);

var Title = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Title",
  componentId: "sc-1hhb1mv-2"
})(["\n  margin-bottom: 20px;\n  font-size: 15px;\n  font-weight: bold;\n"]);

var Items = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Items",
  componentId: "sc-1hhb1mv-3"
})(["\n\n"]);

var Item = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Item",
  componentId: "sc-1hhb1mv-4"
})(["\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 21px;\n  font-weight: bold;\n  padding-bottom: 3px;\n\n  & a{\n    color: ", ";\n    text-decoration: none;\n  }\n  & a:hover{\n    color: ", ";\n    text-decoration: underline;\n  }\n\n"], _consts.WHITESMOKE, _consts.WHITESMOKE);

var Details = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Details",
  componentId: "sc-1hhb1mv-5"
})(["\n  margin-top: 15px;\n  font-size: 15px;\n  line-height: 25px;\n"]);

var Foot = _styledComponents.default.div.withConfig({
  displayName: "OzFooter__Foot",
  componentId: "sc-1hhb1mv-6"
})(["\n  margin-top: 70px;\n  font-size: 15px;\n  text-align: center;\n  line-height: 25px;\n"]);

var OzFooter = function OzFooter(_ref) {
  var _ref$address = _ref.address,
      address = _ref$address === void 0 ? null : _ref$address,
      _ref$rights = _ref.rights,
      rights = _ref$rights === void 0 ? null : _ref$rights,
      _ref$title = _ref.title1,
      title1 = _ref$title === void 0 ? "" : _ref$title,
      _ref$title2 = _ref.title2,
      title2 = _ref$title2 === void 0 ? "" : _ref$title2,
      _ref$title3 = _ref.title3,
      title3 = _ref$title3 === void 0 ? "" : _ref$title3,
      _ref$items = _ref.items1,
      items1 = _ref$items === void 0 ? [] : _ref$items,
      _ref$items2 = _ref.items2,
      items2 = _ref$items2 === void 0 ? [] : _ref$items2,
      _ref$items3 = _ref.items3,
      items3 = _ref$items3 === void 0 ? [] : _ref$items3,
      _ref$logoLink = _ref.logoLink,
      logoLink = _ref$logoLink === void 0 ? null : _ref$logoLink;
  return __jsx(Container, null, __jsx(_OzContainer.default, null, __jsx(_OzRow.default, null, __jsx(_OzCol.default, {
    widthmd: "3"
  }, logoLink ? __jsx(_react.default.Fragment, null) : __jsx(_OzLogo.default, {
    variant: "inverse",
    width: "150px"
  }), __jsx(Details, null, address ? address : __jsx(_react.default.Fragment, null, "Via A. Pacinotti 4/b", __jsx("br", null), "37135 Verona (VR)", __jsx("br", null), "Italia", __jsx("br", null), __jsx("br", null), "+39 045 2456369", __jsx("br", null)))), __jsx(_OzCol.default, {
    widthmd: "3"
  }, __jsx(Menu, null, __jsx(Title, null, title1 ? title1 : __jsx("span", null, "\xA0")), __jsx(Items, null, items1.map(function (item, j) {
    return __jsx(Item, {
      key: j
    }, item);
  })))), __jsx(_OzCol.default, {
    widthmd: "3"
  }, __jsx(Menu, null, __jsx(Title, null, title2 ? title2 : __jsx("span", null, "\xA0")), __jsx(Items, null, items2.map(function (item, j) {
    return __jsx(Item, {
      key: j
    }, item);
  })))), __jsx(_OzCol.default, {
    widthmd: "3"
  }, __jsx(Menu, null, __jsx(Title, null, title3 ? title3 : __jsx("span", null, "\xA0")), __jsx(Items, null, items3.map(function (item, j) {
    return __jsx(Item, {
      key: j
    }, item);
  })))), __jsx(_OzCol.default, {
    widthmd: "12"
  }, __jsx(Foot, null, __jsx("b", null, "\xA9 2022 Ozwol Technologies. ", rights ? rights : "Tutti i diritti riservati."), __jsx("br", null), "Ozwol Technologies S.r.l. - Via A. Pacinotti 4/b, 37135 Verona - Italia", __jsx("br", null), "C.F./P.IVA: 04590420230 - REA: VR-433276 - Camera di Commercio di Verona - CS: \u20AC 10.000 I.V. - PEC: ozwol @ pec . net", __jsx("br", null))))));
};

var _default = OzFooter;
exports.default = _default;